import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { services } from "../data/services";

const allowedRoutes = [
  /^\/$/,
  /^\/home$/,
  /^\/[^/]+$/,
  /^\/property-details\/[^/]+$/,
  /^\/contact-us$/,
  /^\/privacy-policy$/,
  /^\/about-us$/,
  /^\/our-services$/,
  /^\/author\/[^/]+$/,
  /^\/blog-grid$/,
  /^\/blog-detail\/[^/]+$/,
];

const ServiceSchema = () => {
  const { pathname } = useLocation();
  const shouldRenderSchema =
    allowedRoutes.some((pattern) => pattern.test(pathname)) && pathname !== "/404";

  if (!shouldRenderSchema) {
    return null;
  }

  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: "Real Estate Services",
    provider: {
      "@type": "RealEstateAgent",
      name: "AskMe Realty",
    },
    areaServed: {
      "@type": "AdministrativeArea",
      name: "Delhi NCR",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Real Estate Solutions",
      itemListElement: services.map((service) => ({
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: service.title,
          description: service.description,
        },
      })),
    },
  };

  return (
    <Helmet>
      <script id="service-schema" type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default ServiceSchema;
